/**
 * PDP Variant Swap — self-contained variant handling for Riplee's PDP.
 * Reads option selectors directly and resolves variants from a pre-rendered
 * JSON blob. Does not depend on Impulse's variantChange jQuery event —
 * works standalone while also listening for Impulse events as a fallback.
 * v2 — flavour + size gallery filtering
 */
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var container = document.querySelector('[data-section-type="product-template"]')
      || document.querySelector('.product-section');
    if (!container) return;

    var sectionId = container.getAttribute('data-section-id');
    if (!sectionId) return;

    var dataEl = document.getElementById('pdp-flavour-data-' + sectionId);
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('PDP: Could not parse flavour data', e);
      return;
    }

    var variants = data.variants || [];
    var currencyFormat = data.currency_format || '${{amount}}';
    var highlightsMap = data.highlights || {};
    var ingredientCardsMap = data.ingredient_cards || {};
    var ingredientImagesMap = data.ingredient_images || {};

    // ---------------------------------------------------------------
    // Core: resolve variant from current option selector values
    // ---------------------------------------------------------------
    function getCurrentOptions() {
      var options = {};
      var selectors = container.querySelectorAll('.single-option-selector');
      selectors.forEach(function(sel) {
        var idx = sel.getAttribute('data-index'); // "option1", "option2", etc.
        if (idx) options[idx] = sel.value;
      });
      return options;
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        if (options.option1 && v.option1 !== options.option1) match = false;
        if (options.option2 && v.option2 !== options.option2) match = false;
        if (options.option3 && v.option3 !== options.option3) match = false;
        if (match) return v;
      }
      return null;
    }

    function resolveAndUpdate() {
      var options = getCurrentOptions();
      var variant = findVariant(options);
      if (variant) {
        onVariantChange(variant, sectionId, variants, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap);
      }
    }

    // ---------------------------------------------------------------
    // Listen on ALL .single-option-selector elements (our own handling)
    // ---------------------------------------------------------------
    var optionSelectors = container.querySelectorAll('.single-option-selector');
    optionSelectors.forEach(function(sel) {
      sel.addEventListener('change', function() {
        resolveAndUpdate();
      });
    });

    // ---------------------------------------------------------------
    // Flavour swatch click handler (also supports legacy pill class)
    // ---------------------------------------------------------------
    var swatches = container.querySelectorAll('.pdp-hero__swatch, .pdp-hero__pill, .pdp-hero__flavour-pill');
    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var value = this.getAttribute('data-flavour-value');
        var optionIndex = this.getAttribute('data-option-index');

        // Update the hidden selector
        var selector = container.querySelector(
          '.single-option-selector[data-index="' + optionIndex + '"]'
        );
        if (selector) {
          selector.value = value;
          // Trigger change — our listener above picks it up
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update swatch active states immediately
        swatches.forEach(function(s) {
          s.classList.remove('pdp-hero__swatch--active');
          s.classList.remove('pdp-hero__pill--active');
          s.classList.remove('pdp-hero__flavour-pill--active');
          s.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('pdp-hero__swatch--active');
        this.classList.add('pdp-hero__pill--active');
        this.setAttribute('aria-pressed', 'true');
      });
    });

    // ---------------------------------------------------------------
    // Size pill click handler
    // ---------------------------------------------------------------
    var sizePills = container.querySelectorAll('.pdp-hero__size-pill');
    sizePills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var value = this.getAttribute('data-size-value');
        var optionIndex = this.getAttribute('data-option-index');

        // Update the hidden selector
        var selector = container.querySelector(
          '.single-option-selector[data-index="' + optionIndex + '"]'
        );
        if (selector) {
          selector.value = value;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update pill active states within the same group
        var siblings = this.parentElement.querySelectorAll('.pdp-hero__size-pill');
        siblings.forEach(function(s) {
          s.classList.remove('pdp-hero__size-pill--active');
          s.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('pdp-hero__size-pill--active');
        this.setAttribute('aria-pressed', 'true');
      });
    });

    // ---------------------------------------------------------------
    // Purchase option toggle (tab-based: One-time / Subscribe)
    // ---------------------------------------------------------------
    var purchaseTabs = container.querySelectorAll('.pdp-purchase__tab');
    var frequencyRow = document.getElementById('pdp-frequency-' + sectionId);
    var purchaseTypeInput = document.getElementById('pdp-purchase-type-' + sectionId);
    var addBtnTextEl = document.getElementById('pdp-add-btn-text-' + sectionId);

    purchaseTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var selected = this.getAttribute('data-purchase-tab');

        // Toggle active tab
        purchaseTabs.forEach(function(t) {
          var isActive = t.getAttribute('data-purchase-tab') === selected;
          t.classList.toggle('pdp-purchase__tab--active', isActive);
          t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        // Show/hide frequency selector
        if (frequencyRow) {
          frequencyRow.classList.toggle('pdp-purchase__frequency--hidden', selected !== 'subscribe');
        }

        // Update hidden input and button text
        if (purchaseTypeInput) purchaseTypeInput.value = selected;
        if (addBtnTextEl) {
          addBtnTextEl.textContent = selected === 'subscribe' ? 'SUBSCRIBE' : 'ADD TO CART';
        }
      });
    });

    // ---------------------------------------------------------------
    // Frequency pill toggle (Subscribe interval)
    // ---------------------------------------------------------------
    var freqPills = container.querySelectorAll('.pdp-purchase__freq-pill');
    var freqHiddenInput = document.getElementById('pdp-freq-value-' + sectionId);

    freqPills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        freqPills.forEach(function(p) {
          p.classList.remove('pdp-purchase__freq-pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('pdp-purchase__freq-pill--active');
        this.setAttribute('aria-pressed', 'true');
        if (freqHiddenInput) {
          freqHiddenInput.value = this.getAttribute('data-freq-value');
        }
      });
    });

    // ---------------------------------------------------------------
    // Quantity stepper
    // ---------------------------------------------------------------
    var qtyMinus = container.querySelector('[data-pdp-qty-minus]');
    var qtyPlus = container.querySelector('[data-pdp-qty-plus]');
    var qtyInput = container.querySelector('.pdp-hero__qty-input');

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    // ---------------------------------------------------------------
    // Lightbox
    // ---------------------------------------------------------------
    var lightbox = document.getElementById('pdp-lightbox-' + sectionId);
    var lightboxImg = document.getElementById('pdp-lightbox-img-' + sectionId);
    var lightboxCounter = document.getElementById('pdp-lightbox-counter-' + sectionId);
    var lightboxIndex = 0;

    function getLightboxImages() {
      var imgs = [];
      // Main image first
      var mainImg = document.getElementById('pdp-main-img-' + sectionId);
      if (mainImg) {
        imgs.push({
          src: mainImg.getAttribute('data-full-src') || mainImg.src,
          alt: mainImg.alt
        });
      }
      // Then visible secondary images
      var secondaryGrid = document.getElementById('pdp-secondary-grid-' + sectionId);
      if (secondaryGrid) {
        var items = secondaryGrid.querySelectorAll('.pdp-hero__secondary-image:not(.pdp-hero__secondary-image--hidden)');
        items.forEach(function(item) {
          var img = item.querySelector('img');
          if (img) {
            imgs.push({
              src: img.getAttribute('data-full-src') || img.src,
              alt: img.alt
            });
          }
        });
      }
      return imgs;
    }

    function openLightbox(index) {
      if (!lightbox || !lightboxImg) return;
      var imgs = getLightboxImages();
      if (imgs.length === 0) return;
      lightboxIndex = Math.max(0, Math.min(index, imgs.length - 1));
      lightboxImg.src = imgs[lightboxIndex].src;
      lightboxImg.alt = imgs[lightboxIndex].alt;
      if (lightboxCounter) {
        lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + imgs.length;
      }
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function navigateLightbox(dir) {
      var imgs = getLightboxImages();
      if (imgs.length === 0) return;
      lightboxIndex = (lightboxIndex + dir + imgs.length) % imgs.length;
      lightboxImg.style.opacity = '0';
      setTimeout(function() {
        var nextSrc = imgs[lightboxIndex].src;
        var nextAlt = imgs[lightboxIndex].alt;
        if (lightboxCounter) {
          lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + imgs.length;
        }
        var preload = new Image();
        preload.onload = function() {
          lightboxImg.src = nextSrc;
          lightboxImg.alt = nextAlt;
          lightboxImg.style.opacity = '1';
        };
        preload.src = nextSrc;
      }, 160);
    }

    // Trigger lightbox on click — direct binding (Impulse theme stops propagation)
    var galleryEl = document.getElementById('pdp-gallery-' + sectionId);
    if (galleryEl) {
      var mainWrap = document.getElementById('pdp-main-wrap-' + sectionId);

      function handleTriggerClick(trigger) {
        var isMobile = window.innerWidth < 750;
        var mainImg = document.getElementById('pdp-main-img-' + sectionId);

        if (isMobile && trigger !== mainWrap) {
          var img = trigger.querySelector('img');
          if (img && mainImg) {
            var fullSrc = img.getAttribute('data-full-src') || img.src;
            mainImg.style.opacity = '0';
            setTimeout(function() {
              mainImg.src = fullSrc;
              mainImg.srcset = img.getAttribute('data-full-srcset') || '';
              mainImg.alt = img.alt;
              mainImg.style.opacity = '1';
              mainWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 150);
          }
          return;
        }

        var idx = 0;
        if (trigger === mainWrap) {
          idx = 0;
        } else {
          var visibleItems = galleryEl.querySelectorAll('.pdp-hero__secondary-image:not(.pdp-hero__secondary-image--hidden)');
          for (var i = 0; i < visibleItems.length; i++) {
            if (visibleItems[i] === trigger || visibleItems[i].contains(trigger)) {
              idx = i + 1;
              break;
            }
          }
        }
        openLightbox(idx);
      }

      galleryEl.querySelectorAll('[data-lightbox-trigger]').forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          handleTriggerClick(trigger);
        });
      });
    }

    // Lightbox controls
    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(el) {
        el.addEventListener('click', closeLightbox);
      });
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      if (prevBtn) prevBtn.addEventListener('click', function() { navigateLightbox(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { navigateLightbox(1); });

      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') navigateLightbox(-1);
        if (e.key === 'ArrowRight') navigateLightbox(1);
      });
    }

    // ---------------------------------------------------------------
    // Accordion toggle
    // ---------------------------------------------------------------
    var accToggles = document.querySelectorAll('.pdp-accordion__toggle');
    accToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    });

    // ---------------------------------------------------------------
    // Populate accordion content on initial load from data blob
    // (ensures content appears even if Liquid rendering cache is stale)
    // ---------------------------------------------------------------
    (function populateAccordionOnInit() {
      var initOptions = getCurrentOptions();
      var initVariant = findVariant(initOptions);
      if (!initVariant) return;

      var ingredientsEl = document.getElementById('pdp-accordion-ingredients-' + sectionId);
      if (ingredientsEl && initVariant.full_ingredients && !ingredientsEl.textContent.trim()) {
        ingredientsEl.innerHTML = escapeHtml(initVariant.full_ingredients).replace(/\n/g, '<br>');
      }

      var gaEl = document.getElementById('pdp-accordion-ga-' + sectionId);
      if (gaEl && initVariant.guaranteed_analysis && !gaEl.textContent.trim()) {
        gaEl.innerHTML = formatGAasTable(initVariant.guaranteed_analysis);
      }

      var feedEl = document.getElementById('pdp-accordion-feeding-' + sectionId);
      if (feedEl && initVariant.feeding_guide && !feedEl.textContent.trim()) {
        feedEl.innerHTML = escapeHtml(initVariant.feeding_guide).replace(/\n/g, '<br>');
      }
    })();

    // ---------------------------------------------------------------
    // On load: if ?variant= is in the URL, select that variant
    // ---------------------------------------------------------------
    (function selectVariantFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var urlVariantId = params.get('variant');
      if (!urlVariantId) return;
      var targetId = parseInt(urlVariantId, 10);
      var target = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === targetId) { target = variants[i]; break; }
      }
      if (!target) return;

      // Set the hidden option selectors to match the target variant
      var selectors = container.querySelectorAll('.single-option-selector');
      selectors.forEach(function(sel) {
        var idx = sel.getAttribute('data-index');
        if (idx && target[idx]) sel.value = target[idx];
      });

      // Pre-set the main image BEFORE calling onVariantChange so the
      // Turkey image is never visible. Set it directly (no crossfade —
      // the section is hidden anyway) and reveal only after it loads.
      var mainImg = document.getElementById('pdp-main-img-' + sectionId);
      var hasNewImage = mainImg && target.featured_image_url;

      if (hasNewImage) {
        var baseUrl = target.featured_image_url;
        var newSrcset = baseUrl.replace('width=800', 'width=400') + ' 400w, '
          + baseUrl.replace('width=800', 'width=600') + ' 600w, '
          + baseUrl + ' 800w, '
          + baseUrl.replace('width=800', 'width=1000') + ' 1000w';
        var newAlt = (target.featured_image && target.featured_image.alt)
          ? target.featured_image.alt : mainImg.alt;

        mainImg.style.transition = 'none';
        mainImg.src = baseUrl;
        mainImg.srcset = newSrcset;
        mainImg.alt = newAlt;

        var reveal = function() {
          mainImg.style.transition = '';
          document.documentElement.classList.remove('pdp-variant-loading');
          document.documentElement.classList.add('pdp-variant-loaded');
        };

        if (mainImg.complete) {
          reveal();
        } else {
          mainImg.onload = reveal;
          setTimeout(reveal, 2000);
        }
      }

      onVariantChange(target, sectionId, variants, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap);

      if (!hasNewImage) {
        document.documentElement.classList.remove('pdp-variant-loading');
        document.documentElement.classList.add('pdp-variant-loaded');
      }
    })();

    // ---------------------------------------------------------------
    // Also listen for Impulse's variantChange event as backup
    // ---------------------------------------------------------------
    if (typeof jQuery !== 'undefined') {
      jQuery(container).on('variantChange', function(evt) {
        var variant = evt.variant;
        if (!variant) return;

        // Map Impulse variant to our data format
        var mapped = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === variant.id) {
            mapped = variants[i];
            break;
          }
        }
        if (mapped) {
          onVariantChange(mapped, sectionId, variants, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap);
        }
      });
    }
  }

  // -----------------------------------------------------------------
  // Update all PDP elements when variant changes
  // -----------------------------------------------------------------
  function onVariantChange(variant, sectionId, variantData, currencyFormat, container, highlightsMap, ingredientCardsMap, ingredientImagesMap) {
    // Update flavour name in title
    var flavourNameEl = document.getElementById('pdp-flavour-name-' + sectionId);
    if (flavourNameEl && variant.option1) {
      flavourNameEl.textContent = variant.option1;
    }

    // Update pitch
    var pitchEl = document.getElementById('pdp-pitch-' + sectionId);
    if (pitchEl) {
      pitchEl.textContent = variant.pitch || '';
    }

    // Update great-for
    var greatForEl = document.getElementById('pdp-great-for-' + sectionId);
    if (greatForEl) {
      if (variant.great_for) {
        greatForEl.innerHTML = '<strong>Great for</strong> ' + escapeHtml(variant.great_for);
        greatForEl.style.display = '';
      } else {
        greatForEl.style.display = 'none';
      }
    }

    // Update price
    var priceEl = document.getElementById('pdp-price-amount-' + sectionId);
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price, currencyFormat);
    }

    // Update compare-at price
    var compareRow = container.querySelector('.pdp-hero__price-compare');
    if (compareRow) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareRow.textContent = formatMoney(variant.compare_at_price, currencyFormat);
        compareRow.style.display = '';
      } else {
        compareRow.style.display = 'none';
      }
    }

    // Update price size label
    var sizeEl = document.getElementById('pdp-price-size-' + sectionId);
    if (sizeEl && variant.option2) {
      sizeEl.textContent = '/ ' + variant.option2;
    }

    // Update Kibble Coins (both panels)
    var coinsVal = Math.round(variant.price / 100);
    var coinsEl = document.getElementById('pdp-coins-amount-' + sectionId);
    var coinsElSub = document.getElementById('pdp-coins-amount-sub-' + sectionId);
    if (coinsEl) coinsEl.textContent = coinsVal;
    if (coinsElSub) coinsElSub.textContent = coinsVal;

    // Update per-lb pricing on size pills
    var sizePillsContainer = document.getElementById('pdp-size-pills-' + sectionId);
    if (sizePillsContainer) {
      var perLbEls = sizePillsContainer.querySelectorAll('.pdp-hero__size-pill-perlb');
      perLbEls.forEach(function(el) {
        var lbs = parseInt(el.getAttribute('data-size-lbs'), 10);
        var sizeValue = el.closest('.pdp-hero__size-pill').getAttribute('data-size-value');
        if (lbs > 0 && variant.option1) {
          // Find the variant for this flavour + this size
          for (var i = 0; i < variantData.length; i++) {
            if (variantData[i].option1 === variant.option1 && variantData[i].option2 === sizeValue) {
              var perLbPrice = variantData[i].price / lbs;
              el.textContent = '(' + formatMoney(perLbPrice, currencyFormat) + '/lb)';
              break;
            }
          }
        }
      });
    }

    // Update price display
    var onetimePriceEl = document.getElementById('pdp-onetime-price-' + sectionId);
    var onetimeSizeEl = document.getElementById('pdp-onetime-size-' + sectionId);

    if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(variant.price, currencyFormat);
    if (onetimeSizeEl) onetimeSizeEl.textContent = variant.option2 ? '/ ' + variant.option2 : '';

    // Update add-to-cart button
    var addBtn = document.getElementById('pdp-add-btn-' + sectionId);
    var addBtnText = document.getElementById('pdp-add-btn-text-' + sectionId);
    if (addBtn && addBtnText) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtnText.textContent = (typeof theme !== 'undefined' && theme.productStrings)
          ? theme.productStrings.addToCart
          : 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtnText.textContent = (typeof theme !== 'undefined' && theme.productStrings)
          ? theme.productStrings.soldOut
          : 'Sold Out';
      }
    }

    // Update hidden variant ID input (for add-to-cart form)
    var variantInput = document.getElementById('pdp-variant-id-' + sectionId);
    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Update the native ProductSelect dropdown too
    var productSelect = document.getElementById('ProductSelect-' + sectionId);
    if (productSelect) {
      productSelect.value = variant.id;
    }

    // Update flavour swatch/pill active state
    var allSwatches = container.querySelectorAll('.pdp-hero__swatch, .pdp-hero__pill, .pdp-hero__flavour-pill');
    allSwatches.forEach(function(sw) {
      var isActive = sw.getAttribute('data-flavour-value') === variant.option1;
      sw.classList.toggle('pdp-hero__swatch--active', isActive);
      sw.classList.toggle('pdp-hero__pill--active', isActive);
      sw.classList.toggle('pdp-hero__flavour-pill--active', isActive);
      sw.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // Update size pill active state
    var sizeValue = variant.option2 || variant.option1;
    var allSizePills = container.querySelectorAll('.pdp-hero__size-pill');
    allSizePills.forEach(function(pill) {
      var isActive = pill.getAttribute('data-size-value') === sizeValue;
      pill.classList.toggle('pdp-hero__size-pill--active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // Update main image to the variant's featured image (crossfade)
    var mainImg = document.getElementById('pdp-main-img-' + sectionId);
    if (mainImg && variant.featured_image_url) {
      var baseUrl = variant.featured_image_url;
      var newSrcset = baseUrl.replace('width=800', 'width=400') + ' 400w, '
        + baseUrl.replace('width=800', 'width=600') + ' 600w, '
        + baseUrl + ' 800w, '
        + baseUrl.replace('width=800', 'width=1000') + ' 1000w';
      var newAlt = (variant.featured_image && variant.featured_image.alt)
        ? variant.featured_image.alt : mainImg.alt;

      // Preload the new image, then crossfade
      var preload = new Image();
      preload.srcset = newSrcset;
      preload.src = baseUrl;
      preload.onload = function() {
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = baseUrl;
          mainImg.srcset = newSrcset;
          mainImg.alt = newAlt;
          mainImg.style.opacity = '1';
        }, 120);
      };
      // If already cached, onload fires synchronously — handle instant swap
      if (preload.complete) {
        mainImg.src = baseUrl;
        mainImg.srcset = newSrcset;
        mainImg.alt = newAlt;
      }
    }

    // Filter secondary images by flavour + size
    var secondaryGrid = document.getElementById('pdp-secondary-grid-' + sectionId);
    if (secondaryGrid) {
      var items = secondaryGrid.querySelectorAll('.pdp-hero__secondary-image');
      var currentFlavour = variant.option1 || '';
      var currentSize = variant.option2 || '';

      items.forEach(function(item) {
        var imgFlavour = item.getAttribute('data-img-flavour') || '';
        var imgSize = item.getAttribute('data-img-size') || '';

        var show = true;
        if (imgFlavour && normalizeForMatch(imgFlavour) !== normalizeForMatch(currentFlavour)) {
          show = false;
        }
        if (show && imgSize && imgSize !== currentSize) {
          show = false;
        }

        var wasHidden = item.classList.contains('pdp-hero__secondary-image--hidden');
        item.classList.toggle('pdp-hero__secondary-image--hidden', !show);
        if (show && wasHidden) {
          item.classList.remove('pdp-hero__secondary-image--fading-in');
          void item.offsetWidth;
          item.classList.add('pdp-hero__secondary-image--fading-in');
        }
      });
    }

    // Update accordion content
    var ingredientsEl = document.getElementById('pdp-accordion-ingredients-' + sectionId);
    if (ingredientsEl && variant.full_ingredients) {
      ingredientsEl.innerHTML = escapeHtml(variant.full_ingredients).replace(/\n/g, '<br>');
    }

    var gaEl = document.getElementById('pdp-accordion-ga-' + sectionId);
    if (gaEl && variant.guaranteed_analysis) {
      gaEl.innerHTML = formatGAasTable(variant.guaranteed_analysis);
    }

    var feedEl = document.getElementById('pdp-accordion-feeding-' + sectionId);
    if (feedEl && variant.feeding_guide) {
      feedEl.innerHTML = escapeHtml(variant.feeding_guide).replace(/\n/g, '<br>');
    }


    // Swap highlights band per flavour
    if (highlightsMap && variant.option1) {
      var highlights = highlightsMap[variant.option1];
      var hlGrid = document.getElementById('pdp-highlights-grid');
      if (highlights && hlGrid) {
        var hlHtml = '';
        highlights.forEach(function(hl) {
          hlHtml += '<div class="pdp-highlights__item">'
            + '<div class="pdp-highlights__icon">'
            + '<img src="' + escapeHtml(hl.icon) + '" alt="" width="48" height="48">'
            + '</div>'
            + '<div class="pdp-highlights__label">' + escapeHtml(hl.label) + '</div>'
            + '</div>';
        });
        hlGrid.innerHTML = hlHtml;
      }
    }

    // Update ingredient list (numbered rows)
    if (ingredientCardsMap && variant.option1) {
      var cards = ingredientCardsMap[variant.option1];
      var cardsList = document.getElementById('pdp-ingredients-grid');
      if (cards && cardsList) {
        var html = '';
        cards.forEach(function(card, idx) {
          html += '<div class="pdp-ingredients__item">'
            + '<div class="pdp-ingredients__item-number">' + (idx + 1) + '</div>'
            + '<div class="pdp-ingredients__item-content">'
            + '<h3 class="pdp-ingredients__name">' + escapeHtml(card.name) + '</h3>'
            + '<p class="pdp-ingredients__desc">' + escapeHtml(card.desc) + '</p>'
            + '</div></div>';
        });
        cardsList.innerHTML = html;
      }
    }

    // Update ingredient spread image
    if (ingredientImagesMap && variant.option1) {
      var imgUrl = ingredientImagesMap[variant.option1];
      var ingredImg = document.getElementById('pdp-ingredients-img');
      if (imgUrl && ingredImg) {
        ingredImg.style.opacity = '0';
        var preloadIngr = new Image();
        preloadIngr.src = imgUrl;
        preloadIngr.onload = function() {
          ingredImg.src = imgUrl;
          ingredImg.srcset = imgUrl.replace('width=800', 'width=400') + ' 400w, '
            + imgUrl.replace('width=800', 'width=600') + ' 600w, '
            + imgUrl + ' 800w';
          ingredImg.style.opacity = '1';
        };
        if (preloadIngr.complete) {
          ingredImg.src = imgUrl;
          ingredImg.style.opacity = '1';
        }
      }
    }

    // Update sticky mobile CTA
    var stickyPrice = document.getElementById('pdp-sticky-price');
    var stickyFlavour = document.getElementById('pdp-sticky-flavour');
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price, currencyFormat);
    }
    if (stickyFlavour && variant.option1) {
      stickyFlavour.textContent = variant.option1;
    }

    // Push history state
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ variant: variant.id }, '', url.toString());
    }
  }

  // -----------------------------------------------------------------
  // Sticky mobile CTA
  // -----------------------------------------------------------------
  function initStickyBar() {
    var stickyBar = document.getElementById('pdp-sticky-bar');
    if (!stickyBar) return;

    var showAt = 700;
    var visible = false;

    function checkScroll() {
      var shouldShow = window.scrollY > showAt;
      if (shouldShow !== visible) {
        visible = shouldShow;
        stickyBar.classList.toggle('pdp-sticky--visible', visible);
      }
    }

    window.addEventListener('scroll', throttle(checkScroll, 100), { passive: true });

    var stickyAddBtn = stickyBar.querySelector('.pdp-sticky__add-btn');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        var form = document.getElementById('pdp-add-to-cart-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }

  // -----------------------------------------------------------------
  // Utilities
  // -----------------------------------------------------------------
  function formatMoney(cents, format) {
    var dollars = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', dollars)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','));
  }

  function formatGAasTable(str) {
    if (!str) return '';
    return escapeHtml(str).replace(/\n/g, '<br>');
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function normalizeForMatch(str) {
    return (str || '').toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
  }

  function sizedImageUrl(url, size) {
    // Shopify CDN image URL sizing: insert _SIZEx before extension
    if (!url) return url;
    var match = url.match(/^(.*?)(\.(jpg|jpeg|png|gif|webp|avif))(\?.*)?$/i);
    if (match) {
      return match[1] + '_' + size + match[2] + (match[4] || '');
    }
    return url;
  }

  function throttle(fn, wait) {
    var last = 0;
    return function() {
      var now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn.apply(this, arguments);
      }
    };
  }
})();

// AJAX add-to-cart for cross-sell forms (You may also like + Popular Treats)
(function() {
  var selectors = '.pdp-hero__also-like-add, .pdp-treats__add-btn';
  document.addEventListener('click', function(e) {
    var btn = e.target.closest(selectors);
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: data
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added!';
      if (typeof jQuery !== 'undefined') {
        jQuery('body').trigger('added.ajaxProduct', jQuery(btn));
      }
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = btn.classList.contains('pdp-treats__add-btn') ? 'Add to Cart' : '+ Add';
      }, 1500);
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = btn.classList.contains('pdp-treats__add-btn') ? 'Add to Cart' : '+ Add';
      }, 1500);
    });
  }, true);
})();

